export default __webpack_public_path__ + "static/media/metapolis.dd05af87.jpeg";